import { useQuery } from '@tanstack/react-query';
import { log } from '@hungryroot/o11y';
import {
  StatusCode,
  getPromoData,
  type GetPromoDataParams,
} from '@hungryroot/rest';

export function usePromoData(params: GetPromoDataParams) {
  return useQuery({
    queryKey: ['promos'],
    queryFn: async () => {
      const req = await getPromoData(params);
      if (req.status !== StatusCode.SuccessOK) {
        throw req.data;
      }

      if (req.data.promos.length > 0) {
        logPromoCodeApplied(req.data.promos[0]);
      }

      return req.data;
    },
  });
}

/**
 * Critical: These logs are used for DD monitoring to ensure promo codes are being applied correctly
 */
function logPromoCodeApplied(promo: { effect: string; code: string }) {
  const promoCode = promo.code;
  const promoEffect = promo.effect;

  // Evergreen promo codes don't need to be logged
  if (promoCode === '') {
    return;
  }

  try {
    if (sessionStorage.getItem('promo_code_applied') != 'true') {
      log('Promo Code Applied', {
        key: 'useGetPromoData.logPromoCodeApplied',
        effect: promoEffect,
        code: promoCode,
      });
      sessionStorage.setItem('promo_code_applied', 'true');
    }
  } catch {}
}
